/**
 * Рекламный блок сбоку карты (ADR 0019, PROMO §6).
 *
 * ПРАВИЛА, КОТОРЫЕ ЗДЕСЬ НЕЛЬЗЯ «УПРОСТИТЬ»:
 *  1. Блок ОДИН. Не карусель, не лента: карусель превращает карту в рекламный
 *     щит, а платит за это внимание человека, который пришёл найти дверь.
 *  2. Слово «Реклама» и имя заказчика — всегда, без раскрытия по тапу
 *     (Reklaamiseadus §3, UCPD прил. I п. 11a). Скрытая реклама — нарушение,
 *     а не «чище дизайн».
 *  3. Блока нет в состояниях МАРШРУТ/ДВИЖЕНИЕ/АВАРИЯ — за это отвечает
 *     promo.ts, здесь на это полагаемся.
 *  4. Закрыть можно одним тапом, и закрытие держится всю сессию: назойливость
 *     стоит дороже показа.
 */
import { getLang, tr } from '@app/i18n'
import { localized } from '@app/rvf'
import { useEffect, useState } from 'preact/hooks'
import { selectTarget } from '../actions'
import { reportPromoImpression, reportPromoTap } from '../analytics'
import { sidePromo } from '../promo'
import { langTick, venue } from '../state'

/** Закрыто пользователем — до конца сессии (перезагрузка обнуляет). */
let dismissed = false

export function PromoBlock() {
  langTick.value
  const [hidden, setHidden] = useState(dismissed)
  const entry = sidePromo.value
  const v = venue.value
  const venueId = v?.venue.id ?? ''
  const unitId = entry?.unitId ?? ''

  useEffect(() => {
    // Показ считаем, когда блок реально отрисован, а не когда пришли данные.
    if (unitId && venueId && !hidden) reportPromoImpression(venueId, unitId)
  }, [unitId, venueId, hidden])

  if (!entry || hidden || !v) return null
  const lang = getLang()
  const fallback = v.venue.default_language
  const title = entry.promo.label ? localized(entry.promo.label, lang, fallback) : ''
  const offer = entry.promo.offer ? localized(entry.promo.offer, lang, fallback) : ''

  return (
    <aside class="promo-block" aria-label={tr('promo.ad_label')}>
      <div class="promo-block__head">
        {/* Раскрытие — первым, до содержания: человек должен знать, что читает. */}
        <span class="promo-block__tag">{tr('promo.ad_label')}</span>
        <button
          type="button"
          class="promo-block__close"
          aria-label={tr('promo.hide')}
          onClick={() => {
            dismissed = true
            setHidden(true)
          }}
        >
          ✕
        </button>
      </div>
      <button
        type="button"
        class="promo-block__body"
        onClick={() => {
          reportPromoTap(venueId, entry.unitId)
          selectTarget(entry.unitId)
        }}
      >
        {title && <strong class="promo-block__title">{title}</strong>}
        {offer && <span class="promo-block__offer">{offer}</span>}
        <span class="promo-block__by">
          {entry.promo.house
            ? tr('promo.by_owner')
            : tr('promo.paid_by', { name: entry.promo.advertiser })}
        </span>
      </button>
      <a class="promo-block__why" href="/promo-ranking">
        {tr('promo.why_here')}
      </a>
    </aside>
  )
}
